module.exports = __webpack_public_path__ + "static/img/empty.fc6b91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = Bm30
// module chunks = 1